const exported = {
    distributeElementsEquallyIntoCols<T>(items: Array<T>, numCols: number): Array<Array<T>> {
        // given the elements in items, we want to distribute them into numCols such that the number
        // of elements per column differs at most by one.
        // E.g. for 9 elements and 4 columns, we would get [3, 2, 2, 2] children
        // furthermore always the leftmost columns will have the most elements

        const fraction = items.length / numCols;
        const resultRanges = [];

        for (let i = 0; i < numCols; i++) {
            resultRanges.push(items.length % numCols > i ? Math.ceil(fraction) : Math.floor(fraction));
        }

        const result: T[][] = [];
        let offset = 0;

        (resultRanges ?? []).forEach((rangeSize) => {
            result.push(items.slice(offset, offset + rangeSize));
            offset += rangeSize;
        });

        return result;
    }
};

export default exported;

export const { distributeElementsEquallyIntoCols } = exported;
